import { useState } from 'react';
import { navigate } from '../../lib/router';
import { useAuth } from '../../state/auth';
import { useToast } from '../../state/toast';
import { Sheet } from '../../components/ui/Sheet';
import { LogoMark } from '../../components/ui/Logo';
import { LoginForm, RegisterForm } from './AuthForms';
import styles from './auth.module.css';

/** Inline login/register sheet shown when an anonymous user tries a member action. */
export function AuthPrompt() {
  const { authPrompt, closeAuthPrompt, status } = useAuth();
  const [mode, setMode] = useState<'login' | 'register'>('login');
  const toast = useToast();
  if (!authPrompt || status === 'authed') return null;
  const done = () => {
    closeAuthPrompt();
    toast('Welkom bij BlackBlack!', { tone: 'success' });
  };
  return (
    <Sheet open onClose={closeAuthPrompt}>
      <div className={styles.prompt}>
        <LogoMark size={40} />
        <h2>{authPrompt}</h2>
        <div className={styles.switcher} role="tablist">
          <button role="tab" aria-selected={mode === 'login'} onClick={() => setMode('login')}>
            Inloggen
          </button>
          <button role="tab" aria-selected={mode === 'register'} onClick={() => setMode('register')}>
            Registreren
          </button>
        </div>
        {mode === 'login' ? (
          <LoginForm
            onDone={done}
            onForgot={() => {
              closeAuthPrompt();
              navigate('/forgot-password');
            }}
          />
        ) : (
          <RegisterForm onDone={done} />
        )}
      </div>
    </Sheet>
  );
}
